import Api from '../Api';

import { url } from './config';
import { EmailEngagement } from './types';

const api = new Api<EmailEngagement>(url);

export default api;
